import script from "./Material_Center.vue?vue&type=script&setup=true&lang=js"
export * from "./Material_Center.vue?vue&type=script&setup=true&lang=js"

import "./Material_Center.vue?vue&type=style&index=0&id=16a2ece2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16a2ece2"]])

export default __exports__